import React from 'react'
import ReactDOM from 'react-dom/client'
import {App} from './App'
// After App, so it loads after @mantine/core's styles. Without it the list
// tables render unstyled and the sort arrow never flips direction (FNP-1859).
import 'mantine-datatable/styles.css';

import "@fontsource/inter"

// import './assets/sass/index.scss';
import './init/amplify';
// import './init/cloudwatch-rum';
import {Provider} from 'react-redux';
import {store} from "./store/index";

ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
        .render(
            <React.StrictMode>
                <Provider store={store}>
                    <App/>
                </Provider>
            </React.StrictMode>,
        )
